import { createApp } from "vue";
import App from "./App.vue";
import axios from "axios";

import CKEditor from "@ckeditor/ckeditor5-vue";

/*
TIP: To get started with clean router change path to @/router/clean.ts.
 */
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import tr from "element-plus/es/locale/lang/tr";
import en from "element-plus/es/locale/lang/en";
import i18n, { getPreferredLocale } from "@/core/plugins/i18n";
import moment from "moment";

// Element-plus dayjs kullanıyor bizda bazı ayarları yapıyoruz.
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/tr";

// Hafta başlangıç günü pazartesi olarak ayarlanıyor.
dayjs.Ls.en.weekStart = 1;
dayjs.Ls.tr.weekStart = 1;

import lodash from "lodash";
import sprintf from "@jitesoft/sprintf";

import Toast, { useToast } from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

//imports for app initialization
import ApiService from "@/core/services/ApiService";
import { initApexCharts } from "@/core/plugins/apexcharts";
import { initInlineSvg } from "@/core/plugins/inline-svg";
import { initVeeValidate } from "@/core/plugins/vee-validate";

import { vMaska } from "maska/vue"

import VueTelInput from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";

import "@/core/plugins/prismjs";
const app = createApp(App);
const preferredLocale = getPreferredLocale();
const elementLocale = preferredLocale === "tr" ? tr : en;

i18n.global.locale.value = preferredLocale;
axios.defaults.headers.common["Accept-Language"] = preferredLocale;
localStorage.setItem("lang", preferredLocale);

/* app.use( CKEditor ); */
app.use(store);
app.use(router);
app.use(ElementPlus, {
  locale: elementLocale,
});
app.use(CKEditor);
app.use(VueTelInput);

ApiService.init(app);
initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.config.globalProperties.st = store.getters;
{
  /* @ts-ignore */
}
app.config.globalProperties.$t = i18n.global.t;
app.config.globalProperties.moment = moment;
app.config.globalProperties.lodash = lodash;
app.config.globalProperties.toast = useToast();
app.config.globalProperties.sprintf = sprintf;
app.config.globalProperties.ApiService = ApiService;
app.config.globalProperties.gridOverlayLoading = `<div><img src='/loading.gif' width='60' height='60' /><br/><span class='fw-bold' style='color: #c7c7c7'>${i18n.global.t(
  "loading"
)}</span></div>`;

app.use(Toast);

app.directive("maska", vMaska)

app.mount("#app");
